import { createStore,combineReducers } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
 
import getData from './reducers/reducer'
 
const persistConfig = {
  key: 'root',
  storage,
}
 
const persistedReducer = persistReducer(persistConfig, combineReducers({getData: getData}))
 
  let store = createStore(persistedReducer)
  let persistor = persistStore(store)
export { persistor, store };